export default {"src":"/_next/static/media/notification-bell.0867fcec.svg","height":24,"width":24};